import * as React from 'react';

import Menu from 'antd/lib/menu';

export interface GearAction {
    id: string,
    label: string;
    onClick: (
        event: React.MouseEvent<any>,
    ) => void;
}

// ** Antd Menu + Menu.Item
// ** don't seem to work well within a HOC
// ** replacing with a simple js function
// ** to build the actions menu 
export const buildGearActionsMenu = (actions: GearAction[]) => (
    <Menu
        className="ant-dropdown-menu--theme"
    >
        {
            actions.map(({ id, label, onClick }) => (
                <Menu.Item key={id}>
                    <a onClick={(event) => {
                        onClick(event);
                    }}>
                        {label}
                    </a>
                </Menu.Item>
            ))
        }
    </Menu>
);
